module.exports = __webpack_public_path__ + "img/DOWNLOAD.3fff2b85.svg";